import { computed } from 'vue'
import { useStore } from 'vuex'

import { APP_MODULE_IDS } from '@root/disabled-modules'

export const useDisabledModules = () => {
  const store = useStore()

  const getIsModuleDisabled = ({ moduleId }) => {
    return store.getters['appContext/isModuleDisabled']({ moduleId })
  }

  const disabledModules = computed(() => store.state.appContext.disabledModules)

  const isBillingModuleDisabled = computed(() => {
    return getIsModuleDisabled({
      moduleId: APP_MODULE_IDS.BILLING
    })
  })

  const isConnectionDisconnectionModuleDisabled = computed(() => {
    return getIsModuleDisabled({
      moduleId: APP_MODULE_IDS.CONNECTION_DISCONNECTION_MODULE
    })
  })

  const isSSOModuleDisabled = computed(() => {
    return getIsModuleDisabled({
      moduleId: APP_MODULE_IDS.SSO
    })
  })

  const isSwitchOrganizationModuleDisabled = computed(() => {
    return getIsModuleDisabled({
      moduleId: APP_MODULE_IDS.SWITCH_ORGANIZATION
    })
  })

  const isLogoutModuleDisabled = computed(() => {
    return getIsModuleDisabled({
      moduleId: APP_MODULE_IDS.LOGOUT
    })
  })

  return {
    disabledModules,
    isBillingModuleDisabled,
    isConnectionDisconnectionModuleDisabled,
    isSSOModuleDisabled,
    isSwitchOrganizationModuleDisabled,
    isLogoutModuleDisabled
  }
}
